import {MediaStateType} from "../media/MediaTypes";
import {ITunesExplicit} from "../itunes/ItunesCategories";

interface IFeedViewData {
    feedId: number;
    cId: number;
    mediaStateType: MediaStateType;
    posterFileId: number | null;
    descShort: string | null;
    title: string;
    itunesCategory: string | null;
    itunesExplicit: ITunesExplicit;
    language: string;
    sources: IFeedSourceData[],
    created: number;
    updated: number;
}

interface IFeedSourceData {
    feedSourceId: number;
    feedId: number;
    listId: number;
    position: number;
    title: string;
}

interface IFeedCreateReq {
    descShort: string | null;
    language: string | null;
    itunesCategory: string | null;
    itunesExplicit: ITunesExplicit | null;
    mediaStateType: MediaStateType;
    title: string;
    sources: IFeedSourceCreateReq[];
}

interface IFeedSourceCreateReq {
    listId: number;
    position: number;
    title: string;
}

enum FeedFormat{
    ITunes = "itunes",
    FireTV="firetv",
    Mrss="mrss",
    Roku ="Roku"
}

export {
    FeedFormat,
    IFeedCreateReq,
    IFeedViewData,
    IFeedSourceData
}